/* Observateur unique partagé par toutes les sections bm-*.
   Le script est inclus par plusieurs sections : ce garde-fou évite
   de l'exécuter deux fois. */
(function () {
  if (window.__bmRevealInit) return;
  window.__bmRevealInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(scope) {
    (scope || document).querySelectorAll('[data-bm-reveal]').forEach(function (el) {
      el.classList.add('bm-revealed');
    });
  }

  if (reduce || !('IntersectionObserver' in window)) {
    document.addEventListener('DOMContentLoaded', function () { revealAll(); });
    revealAll();
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('bm-revealed');
      io.unobserve(entry.target); /* déclenché une seule fois */
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -5% 0px' });

  function observe(scope) {
    (scope || document).querySelectorAll('[data-bm-reveal]:not(.bm-revealed)').forEach(function (el) {
      /* Déjà visible au chargement : on révèle sans attendre */
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) { el.classList.add('bm-revealed'); return; }
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { observe(); });
  else observe();

  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
})();
